import { isSSR } from '../Utils/ssrUtils.js';

export const shouldShowDebuggingInfo = (isDebugMode = false): boolean => {
  if (isSSR()) {
    return false;
  }
  return /ricos-debug/i.test(window.location.search) || isDebugMode;
};
